import { render, staticRenderFns } from "./training.create.completed.vue?vue&type=template&id=c0ebdd2e&scoped=true&"
import script from "./training.create.completed.vue?vue&type=script&lang=js&"
export * from "./training.create.completed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ebdd2e",
  null
  
)

export default component.exports